/* tslint:disable */

import { Log } from 'ng2-logger';
import React from 'react';
import {Modal } from 'reactstrap';
import { Common } from '../../core/common';
import Translator from '../../core/i18n';
import { CoursePageService } from '../../api/course-page-service';
import Input from '../../components/input/text/input-formik';
import { Quil } from '../../components/input/quil/main';
import { Formik } from 'formik';
import { SelectNoneAsync } from '../../components/input/select/main';

const _logger = Log.create('ActivityCardMain.tsx');
const T = Translator.create();
let _common: Common;
const coursePageService = new CoursePageService();
let active = 0;
const _lodash = require('lodash');



class RolesModal extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        _common = new Common();

        this.state = {
            filterInitialValues: {
                searchTermId: '',
                searchProgId: '',
                masterCourseId: '',
                sourceCourseId: '',
                status: -1,
                searchCourseName: '',
                courseId: ''
            }
        };
    
    }


    setClose = (refresh: boolean = false) => {
        this.props.onClose(refresh);
    };

    onSubmit = () => {
       console.log("submit")
    };

    onSelectRoleChange = () => {
        console.log("rolechange")

    };

    render() {


        return (
            <Modal
                isOpen={true}
                modalClassName={'add-activity-modal modal-from-right slideInRight show animated'}
                fade={true}
                style={{ display: 'block', animationDuration: '0.5s', padding: "0px!important" }}

            >
             <div className="modal-dialog"  style={{ width: '27vw' }}>
             <div className="modal-content">
             <div className="modal-header d-flex justify-content-start">
                                                <h5 className="modal-title d-flex align-items-center">
                                                    {T.t('r_system_roles_new_title')}
                                                </h5>
                                                <button
                                                    type="button"
                                                    className="close"
                                                    data-dismiss="modal"
                                                    aria-label="Close"
                                                    onMouseDown={event => this.setClose(false)}
                                                >
                                                    <i style={{ color: '#000' }} className="material-icons">
                                                        close
                                                    </i>
                                                    <span>{T.t('r_gen_close')}</span>
                                                </button>
                                            </div>

                                            <div className='modal-body pt-0'>
                <div
                id="video-setting"
                role="tabpanel"
                aria-labelledby="video-setting-tab"
            >
                  <Formik
                    initialValues={this.state.filterInitialValues}
                    onSubmit={this.onSubmit}
                >
                       {formik => {
                        return (
                            <form onSubmit={formik.handleSubmit} key={'project_add_user_modal'} noValidate={true}>
<div className="ml-1" style={{ width: '100%' }}>
                <Input type={'text'}  name={'name'} placeHolder={T.t('r_system_roles_new_role_name')} formik={formik} />
                </div>
                                            <div className="m-0" style={{ width: '100%' }}>
                                                                <SelectNoneAsync
                                                                    name={`roles`}
                                                                    setOptions={[
                                                                        { value: 1, label: 'Yönetici' },
                                                                        { value: 2, label: 'Eğitmen' },
                                                                        { value: 3, label: 'Öğrenci' },
                                                                        { value: 4, label: 'Program Yöneticisi' }
                                                                    ]}
                                                                    // tslint:disable-next-line:jsx-no-lambda
                                                                    onChange={(e: any) =>
                                                                      this.onSelectRoleChange
                                                                    }                                                              
                                                                    placeHolder={T.t('r_system_roles_main_role')}
                                                                />
                                                            </div>
                                                            
                <div className="m-0" style={{ width: '100%' }}>
                <h5 className="mt-4 mb-2">{T.t('r_description')}</h5>
                <Quil
                    modules={'basic'}
                    placeholder={T.t('r_write_description_for_aroles')}
                    // tslint:disable-next-line:jsx-no-lambda
                    theme={'snow'}
                /> 
                </div>
                </form>
                )
                }}
                </Formik>
                
                </div>
            </div>
            </div>
            </div>
               
            </Modal>
        );
    }
}

export default RolesModal;
